import { ROOT_URL } from "./secrets"

export const LOGIN_ENDPOINT = `${ROOT_URL}/login`
export const GRAPHQL_ENDPOINT = `${ROOT_URL}/api/graphql`
export const FORGET_ENDPOINT = `${ROOT_URL}/forgot`
export const FORGET_CLIENT_ENDPOINT = `${ROOT_URL}/client/forgot`
export const RESET_ENDPOINT = `${ROOT_URL}/reset/`
export const CLIENT_LOGIN_ENDPOINT = `${ROOT_URL}/client/login/`
export const RESET_DRIVER_ENDPOINT = `${ROOT_URL}/driver/reset/`
export const RESET_CLIENT_ENDPOINT = `${ROOT_URL}/client/reset/`
export const XERO_AUTH_ENDPOINT = `${ROOT_URL}/xero/auth`
export const BASE_URL = ROOT_URL
